import MicroModal from "micromodal";
import ModalVideo from "./ModalVideo";

const Video = (props) => {
    const { video } = props;
    return (
        <>
            <div
                className="w-10/12 lg:w-7/12 max-w-800p mx-auto my-20 relative"
                onClick={() => {
                    MicroModal.show('modal-video', {
                        awaitCloseAnimation: true
                    })
                }}
            >
                <div className="sobre-video bg-rosado bg-opacity-30 absolute top-0 w-full h-full cursor-pointer"></div>
                <iframe
                    className="w-full h-96 lg:h-500p"
                    src={video}
                    title="video de la historia">
                </iframe>
            </div>
            <ModalVideo nombreModal="modal-video" video={video} />
        </>
    )
}

export default Video;